<template>
  <div class="teaser-big">
    <div class="content">
      <h3 v-if="data.title" class="title" v-html="data.title" />
      <StructuredText v-if="data.lead" class="structured-text lead" :data="data.lead" />
    </div>
    <Link v-if="data.link" :link="data.link" class="button-primary button" icon-position="left" />
  </div>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import type { TeaserBigFragment } from '#gql';
import Link from '~/components/content-modules/components/Link.vue';

defineProps<{
  data: TeaserBigFragment;
}>();
</script>

<style scoped lang="scss">
.teaser-big {
  background-color: var(--color-forest-light);
  color: var(--color-forest-dark);
  padding: var(--spacing-sm);
  min-height: 22.5rem;
  height: 100%;
  display: grid;
  align-content: space-between;
  justify-items: start;

  @media (--xs), (--sm) {
    padding: var(--spacing-xs);
    height: 100%;
    min-height: 22rem;
  }

  > .content {
    > .title {
      color: var(--color-forest-dark);
    }

    > .lead {
      margin: var(--spacing-3xs) 0 calc(2 * var(--spacing-3xs));
    }
  }

  :deep(.button) {
    color: var(--color-forest-dark);

    &:focus-visible {
      border: 2px solid var(--color-forest-dark);
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover > .iconwrapper {
        background: var(--color-turquoise);
      }

      &:hover > .iconwrapper > .icon {
        fill: var(--color-white);
      }
    }

    > .iconwrapper {
      background: var(--color-white);

      > .icon {
        fill: var(--color-forest-dark);
      }
    }
  }
}
</style>
